import type { ReactNode, JSX } from 'react';
import { TableCell, TableRow } from '@/components/ui/table';

export interface ListStateRowProps {
  /** Number of columns to span. */
  colSpan: number;
  /** The state content (icon + copy + optional retry button). */
  children: ReactNode;
  /** Classes for the spanning cell (height + centering, verbatim per legacy). */
  className?: string;
  /** Optional testid on the `<TableRow>` (some lists tag the row, e.g. `users-empty-row`). */
  rowTestId?: string;
  /** Optional testid on the spanning `<TableCell>`. */
  cellTestId?: string;
}

/**
 * A full-width table-body row for empty / no-matches / error states. Every
 * list page repeated the same `<TableRow><TableCell colSpan=…>` wrapper; this
 * captures only that wrapper so each page keeps its own icon, copy, and retry
 * affordance (and its exact testids, passed in) while dropping the boilerplate.
 */
export function ListStateRow({
  colSpan,
  children,
  className,
  rowTestId,
  cellTestId,
}: ListStateRowProps): JSX.Element {
  return (
    <TableRow data-testid={rowTestId}>
      <TableCell colSpan={colSpan} className={className} data-testid={cellTestId}>
        {children}
      </TableCell>
    </TableRow>
  );
}
